// @flow
import styled, { css } from 'styled-components';
import { flamingo } from '../../colors';
import InfoBubbleTheme from '../../info-bubble/theme';
/*::
import type { Node } from 'react';
import type { InfoBubbleThemeType } from '../../info-bubble';

export type CheckboxThemeType = {|
  Main: * => Node,
  InlineFlex: * => Node,
  IconWrapper: * => Node,
  Input: * => Node,
  Label: * => Node,
  InfoBubbleTheme: InfoBubbleThemeType;
|};
*/

var thm
/*: CheckboxThemeType */
= {
  Main: styled.span.withConfig({
    displayName: "theme__Main",
    componentId: "qf9wgw-0"
  })(["height:4rem;display:flex;align-items:center;"]),
  InlineFlex: styled.span.withConfig({
    displayName: "theme__InlineFlex",
    componentId: "qf9wgw-1"
  })(["display:inline-flex;align-items:center;"]),
  IconWrapper: styled.span.withConfig({
    displayName: "theme__IconWrapper",
    componentId: "qf9wgw-2"
  })(["position:relative;display:inline-block;width:", "rem;height:", "rem;&:hover .stroke-rect{stroke:", ";}&:before{box-sizing:border-box;content:\"\";display:block;height:4rem;width:4rem;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%) scale(", ");opacity:", ";border-radius:50%;background-color:", ";transition:all 0.2s ease-out;}", ""], function (pr) {
    return pr.checkboxWidth;
  }, function (pr) {
    return pr.checkboxWidth;
  }, function (pr) {
    return pr.color;
  }, function (pr) {
    return pr.clicked ? 1 : 0;
  }, function (pr) {
    return pr.clicked ? '0.12' : '0';
  }, flamingo(), function (pr) {
    return !pr.clicked && css(["&:hover{&:before{transform:translate(-50%,-50%) scale(1);opacity:0.04;}}"]);
  }),
  Input: styled.input.attrs(function () {
    return {
      type: 'checkbox'
    };
  }).withConfig({
    displayName: "theme__Input",
    componentId: "qf9wgw-3"
  })(["position:absolute;top:0;left:0;opacity:0;width:100%;height:100%;border:0;padding:0;margin:0;cursor:pointer;"]),
  Label: styled.label.withConfig({
    displayName: "theme__Label",
    componentId: "qf9wgw-4"
  })(["cursor:pointer;margin-left:1rem;"]),
  InfoBubbleTheme: InfoBubbleTheme
};
export default thm;